import React from "react";
import { useNavigate } from "react-router-dom";
import './css/Jobs.css'

const Jobs = () => {
   const navigate = useNavigate();
  return (
    <div className="jobs-page">
      {/* Hero Section */}
      <section className="jobs-hero">
        <h1>Join Our Team</h1>
        <p>
          Be a part of our mission to transform agriculture through innovation,
          technology, and sustainable practices.
        </p>
      </section>

      {/* Job Listings */}
      <section className="jobs-list">

        {/* Tractor Driver */}
        <div className="job-card">
          <h2>Tractor Driver</h2>
          <p className="job-location">📍 Field Operations</p>
          <p className="job-desc">
            We are looking for skilled and responsible Tractor Drivers to
            support modern farming operations and ensure efficient field work.
          </p>

          <ul>
            <li>Operate tractors and farming machinery</li>
            <li>Perform basic maintenance checks</li>
            <li>Assist in field preparation and harvesting</li>
            <li>Valid driving license (minimum 4 vehicle license preferred)</li>
          </ul>

          <button
  className="apply-btn"
  onClick={() => navigate("/apply/tractor-driver")}
>
  Apply Now
</button>

        </div>

        {/* Drone Pilot */}
        <div className="job-card">
          <h2>Drone Pilot</h2>
          <p className="job-location">📍 Aerial Operations</p>
          <p className="job-desc">
            We are hiring certified Drone Pilots for agricultural spraying,
            aerial surveys, and precision farming operations.
          </p>

          <ul>
            <li>Operate agricultural drones for spraying and mapping</li>
            <li>Ensure safe and accurate flight operations</li>
            <li>Maintain drone equipment</li>
            <li>DGCA certification preferred</li>
          </ul>

 <button
  className="apply-btn"
  onClick={() => navigate("/apply/drone-pilot")}
>
  Apply Now
</button>

        </div>

        {/* Software Engineer */}
        <div className="job-card">
          <h2>Software Engineer</h2>
          <p className="job-location">📍 Technology & Platforms</p>
          <p className="job-desc">
            Looking for Software Engineers to build and maintain digital
            platforms for smart agriculture and machine management systems.
          </p>

          <ul>
            <li>Develop web or mobile applications</li>
            <li>Work on IoT, analytics, or automation systems</li>
            <li>Collaborate with field and product teams</li>
            <li>Experience in React / Python / Node preferred</li>
          </ul>

<button
  className="apply-btn"
  onClick={() => navigate("/apply/software-engineer")}
>
  Apply Now
</button>

        </div>

        {/* Warehouse Incharge */}
        <div className="job-card">
          <h2>Warehouse Incharge</h2>
          <p className="job-location">📍 Warehouse & Logistics</p>
          <p className="job-desc">
            Responsible for managing inventory, machinery parts, and warehouse
            operations efficiently.
          </p>

          <ul>
            <li>Manage stock and inventory records</li>
            <li>Coordinate inbound and outbound logistics</li>
            <li>Ensure safety and cleanliness standards</li>
            <li>Basic computer knowledge required</li>
          </ul>

<button
  className="apply-btn"
  onClick={() => navigate("/apply/warehouse-incharge")}
>
  Apply Now
</button>

        </div>

        {/* Machinery / Machines Controller */}
        <div className="job-card">
          <h2>Machinery & Machine Operator</h2>
          <p className="job-location">📍 Operations Control</p>
          <p className="job-desc">
            Oversee deployment, usage, and monitoring of tractors, implements,
            and agricultural machines.
          </p>

          <ul>
            <li>Schedule machine operations</li>
            <li>Monitor performance and usage</li>
            <li>Coordinate maintenance activities</li>
            <li>Field operations experience preferred</li>
          </ul>

<button
  className="apply-btn"
  onClick={() => navigate("/apply/machinery-controller")}
>
  Apply Now
</button>

        </div>

        {/* Drivers (Multiple Vehicles) */}
        <div className="job-card">
          <h2>Multi-Vehicle Driver</h2>
          <p className="job-location">📍 Field & Logistics</p>
          <p className="job-desc">
            Drivers required for tractors and other agricultural vehicles
            with experience in handling multiple vehicle types.
          </p>

          <ul>
            <li>Operate tractors and support vehicles</li>
            <li>Transport machinery and materials</li>
            <li>Follow safety and driving regulations</li>
            <li>Minimum 4-vehicle valid driving license required</li>
          </ul>

<button
  className="apply-btn"
  onClick={() => navigate("/apply/tractor-driver")}
>
  Apply Now
</button>

        </div>

        {/* Marketing Team */}
        <div className="job-card">
          <h2>Marketing Executive (Online & Offline)</h2>
          <p className="job-location">📍 Sales & Marketing</p>
          <p className="job-desc">
            We are expanding our marketing team to promote agricultural services,
            machinery, and digital platforms.
          </p>

          <ul>
            <li>Plan and execute marketing campaigns</li>
            <li>Handle online marketing (social media, ads)</li>
            <li>Coordinate offline promotions and farmer outreach</li>
            <li>Good communication skills required</li>
          </ul>

<button
  className="apply-btn"
  onClick={() => navigate("/apply/marketing")}
>
  Apply Now
</button>

        </div>

        {/* Agronomist */}
        <div className="job-card">
          <h2>Agronomist</h2>
          <p className="job-location">📍 Research & Field Support</p>
          <p className="job-desc">
            We are seeking passionate Agronomists to improve crop productivity
            through scientific methods and sustainable agricultural practices.
          </p>

          <ul>
            <li>Analyze soil and crop health</li>
            <li>Provide crop and fertilizer recommendations</li>
            <li>Support farmers with modern techniques</li>
            <li>Monitor field trials and data</li>
          </ul>

<button
  className="apply-btn"
  onClick={() => navigate("/apply/agronomist")}
>
  Apply Now
</button>

        </div>

      </section>
    </div>
  );
};

export default Jobs;
